import { Cents } from '@systemeio/ui'
import {
  BillingPeriodCaptionEnum,
  BillingPeriodEnum,
} from 'modules/profile/user-plan/enums/billing-period-enum'
import { UserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface'

export function calculatePlanParameters(
  pricePlan: UserPlanInterface,
  billingPeriod: BillingPeriodEnum,
): {
  calculatedCost: Cents
  calculatedCostWithTax: Cents
  calculatedLink: string
  calculatedPeriod: string
} {
  const calculatedCost =
    billingPeriod === BillingPeriodEnum.monthly ? pricePlan.monthCost : pricePlan.annualCost

  const calculatedCostWithTax =
    billingPeriod === BillingPeriodEnum.monthly
      ? pricePlan.monthCostWithTax
      : pricePlan.annualCostWithTax

  const calculatedLink =
    billingPeriod === BillingPeriodEnum.monthly
      ? pricePlan.offerLinkMonthly
      : pricePlan.offerLinkAnnual

  const calculatedPeriod =
    billingPeriod === BillingPeriodEnum.monthly
      ? BillingPeriodCaptionEnum[BillingPeriodEnum.monthly]
      : BillingPeriodCaptionEnum[BillingPeriodEnum.annual]

  return {
    calculatedCost,
    calculatedCostWithTax,
    calculatedLink,
    calculatedPeriod,
  }
}
